import axiosInstance from '../../util/axiosAPI';
import { API_URL } from '../../config';

export default class SystemService {

    constructor() { }


    restart() {
        const url = `${API_URL}/api/system/restart/`;
        return axiosInstance.get(url).then(response => response.data);
    }

}